import { unitsForAllTickets } from "@api/e-tickets/unitsForAllTicket";
import { useEffect, useState } from "react";

export const useUnitsForAllTickets = () => {
  const [units, setUnits] = useState([]);

  useEffect(() => {
    unitsForAllTickets()
      .then((data) => {
        setUnits(data);
      })
      .catch(() => {
        setUnits([]);
      });
  }, []);

  return {
    units,
  };
};
